import { Button, ButtonColor } from '@leland-dev/leland-ui-library';
import React from 'react';

import { CoachVisibility } from '../../__generated-gql-types__/globalTypes';
import { getCTATooltipTextForBlockedUser } from '../../utils/coach';
import {
  getOfferingPackageCoachingTimeLabel,
  getOfferingPackagePriceLabel,
} from '../../utils/package';

import type { OfferingPackageBottomCtaOfferingPackageFragment } from './__generated-gql-types__/OfferingPackageBottomCTA.generated';

interface OfferingPackageBottomCTAProps {
  offeringPackage: OfferingPackageBottomCtaOfferingPackageFragment;
  onPurchaseOrSelectTier: () => void;
  isLoading: boolean;
  blocked?: boolean;
}

const OfferingPackageBottomCTA: React.FC<OfferingPackageBottomCTAProps> = ({
  offeringPackage,
  onPurchaseOrSelectTier,
  isLoading,
  blocked,
}) => {
  const offeringPackageCoachingTimeLabel = getOfferingPackageCoachingTimeLabel(
    offeringPackage.prices,
  );

  const disabled = isLoading || blocked;
  const blockedUserCTAText = getCTATooltipTextForBlockedUser(
    offeringPackage.coach.user.firstName,
  );
  const noContactForNewClient =
    offeringPackage.coach.visibility === CoachVisibility.PRIVATE_CLOSED &&
    !offeringPackage.coach.coachingRelationship;

  return (
    <div className="fixed bottom-0 flex h-20 w-full items-center justify-between space-x-4 border-t bg-white p-4 md:hidden">
      <div className="flex flex-col items-start justify-center">
        <h3 className="text-xl font-medium leading-snug text-leland-gray-dark">
          {getOfferingPackagePriceLabel(offeringPackage.prices)}
        </h3>
        {offeringPackageCoachingTimeLabel ? (
          <p className="text-lg font-normal leading-snug text-leland-gray-light">
            {offeringPackageCoachingTimeLabel}
          </p>
        ) : null}
      </div>
      {noContactForNewClient ? null : (
        <Button
          label={
            offeringPackage.prices?.length === 1 ? 'Purchase' : 'Select a size'
          }
          buttonColor={ButtonColor.PRIMARY}
          disabled={disabled}
          tooltipContent={blocked ? blockedUserCTAText : null}
          rounded
          onClick={onPurchaseOrSelectTier}
          id="offering_package_bottom_cta--purchase_or_select_size"
        />
      )}
    </div>
  );
};

export default OfferingPackageBottomCTA;
